import styled from "styled-components";
import { FlexSection, FlexContainer, FlexDiv } from "@/components/Atoms/Box";
import Typography from "@/foundation/Typography/V2";

export const Wrapper = styled(FlexSection)`
  padding: ${({ isLastSection }) =>
    isLastSection ? "0px 0 72px" : "0px 0 20px"};
  background-color: ${({ theme }) => theme.colorsV2.gray.shade_25};
  ${({ isLastSection }) => isLastSection && `padding-bottom:52px;`}
  ${({ isBelowHeroSection, theme, isLastSection }) =>
    isBelowHeroSection
      ? `
    position: relative;
    &:after {
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        max-height: 30%;
        background-color: ${theme.colorsV2.shyft.logo_purple};
        z-index: 0;
    }
    > div {
        position: relative;
        z-index: 1;
    }
    @media only screen and (max-width: 1079px) {
      padding: 16px 0 20px;
      &:after{
        content:normal;
      }
    }
  `
      : `
      @media only screen and (max-width: 1079px) {
        padding: ${isLastSection ? "20px 0 72px" : "20px 0 20px"};
      }
  `}
  @media only screen and (max-width: 1079px) {
    background-color: ${({ theme }) => theme.colorsV2.gray.shade_200};
  }
`;
export const Container = styled(FlexContainer)`
  flex-direction: column;
  @media only screen and (max-width: 1079px) {
    padding: 0 8px;
  }
`;
export const HealthConditionCard = styled(FlexDiv)`
  flex-direction: column;
  background-color: ${({ theme, isForm }) =>
    isForm ? theme.colors.white : theme.colorsV2.gray.shade_50};
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colorsV2.gray.shade_300};
  box-shadow: 0px 0px 4px
      rgba(${({ theme }) => theme.colors.shadows.black}, 0.04),
    0px 8px 16px rgba(${({ theme }) => theme.colors.shadows.black}, 0.08);
  overflow: hidden;
  @media only screen and (max-width: 1079px) {
    border: 0;
    background-color: ${({ theme }) => theme.colorsV2.gray.shade_100};
    box-shadow: none;
  }
`;
export const HeadingBox = styled(FlexDiv)`
  padding: 0 80px 0 64px;
  position: relative;
  flex-direction: column;
  margin-bottom: 48px;
  @media only screen and (max-width: 1079px) {
    margin-bottom: 24px;
    padding: 0 8px;
  }
`;
export const Count = styled(Typography)`
  color: ${({ theme }) => theme.colors.white};
  position: absolute;
  top: 50%;
  left: 0;
  user-select: none;
  transform: translateY(-50%);
  background-color: ${({ theme }) => theme.colorsV2.shyft.purple_text};
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media only screen and (max-width: 1079px) {
    height: 32px;
    width: 32px;
    top: 18px;
    left: 8px;
  }
`;
export const Title = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_600};
  @media only screen and (max-width: 1079px) {
    padding: 4px 0 4px 40px;
  }
`;
export const Subtitle = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_700};
  margin-top: 8px;
`;
